'use client';
import { SessionProvider } from 'next-auth/react';
import React from 'react';
import SessionStoreGuard from './SessionStoreGuard';

type Props = {
  children: React.ReactNode;
};

export default function NextAuthProvider({ children }: Props) {
  return (
    <SessionProvider refetchOnWindowFocus={false} refetchInterval={30 * 60}>
      <SessionStoreGuard />
      {children}
    </SessionProvider>
  );
}
